import { render, staticRenderFns } from "./TaxonomyItemSelect.vue?vue&type=template&id=6be4b43b"
import script from "./TaxonomyItemSelect.vue?vue&type=script&lang=js"
export * from "./TaxonomyItemSelect.vue?vue&type=script&lang=js"
import style0 from "./TaxonomyItemSelect.vue?vue&type=style&index=0&id=6be4b43b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports